import React, { Component } from "react";
import Layout from "../Layout";
import PropagateLoader from "react-spinners/PropagateLoader";
import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faEye,
  faFilePdf,
  faQuestionCircle,
  faFileExcel,
} from "@fortawesome/free-solid-svg-icons";
import {
  Modal,
  Button,
  ButtonGroup,
  Row,
  Col,
  OverlayTrigger,
  Popover,
  Form,
  ButtonToolbar,
  Table
} from "react-bootstrap";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ReactTooltip from "react-tooltip";
import Adjunto from "./Adjunto";
import Galeria from "./Galeria";
import ListaAdjuntos from "./ListaAdjuntos";
import ReportePDF from "./ReportePDF";

class F19s extends Component {
  constructor(props) {
    super(props);
    this.GetActionFormat = this.GetActionFormat.bind(this);
    this.state = {
      // Estado relacionado con el modelo
      id: "",
      check: [],
      observaciones: "",
      usuario_id: "",
      ambito_id: "",

      // Estados para la ventana modal
      modal: false, // ventana modal generica para modificar y Nuevo cerrada
      modalEliminar: false, //Modal Eliminar
      modalVisualizar: false, //Modal Visualizar
      modalAccion: "", // Acción del boton principal de la ventana modal para el switch
      modalTitle: "", // Titulo para la ventana modal generica
      frm_lista_documentos: [], // Lista de documentos del registro
      frm_archivo: null,
      frm_descripcion_doc: "",
      f19s: [], // Listado de elementos para la tabla
      loading: false,
      noEdit: false,
    };
  }

  componentDidMount = () => {
    this.cargaTabla();
  }
  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  noEditFnc = async () => {
    let noEdit = false
    let busca = this.props.location.pathname.split("/")
    busca.shift()
    let misAmbitos = localStorage.ambitos.split(",")

    if (busca[2]) {
      let res = null
      res = await axios({
        method: "get",
        url:
          "http://143.198.191.211/api/Ambito/" +
          busca[2] +
          "?api_token=" +
          localStorage.api_token,
        data: {},
      })

      let data = res.data
      if (data.fecha_finalizado != null) {
        noEdit = true
      } else {
        if (misAmbitos.includes(busca[2])) {
          noEdit = false
        } else {
          noEdit = true
        }
      }

      if (localStorage.permisos.includes("admin")) {
        noEdit = false
      }
    }
    if (noEdit) {
      this.setState({ noEdit: true })
    } else {
      this.setState({ noEdit: false })
    }
  }

  cargaTabla = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/F19/ambito/" +
        this.props.match.params.ambito_id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.setState({ f19s: res.data, loading: false });
    }).finally(() => {
      this.noEditFnc();
    });
  };

  cargaDocumentos = (id) => {
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/Documento/" +
        this.props.match.params.ambito_id +
        "/19/" +
        id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.closeModalDocumentos();
      this.setState({ frm_lista_documentos: res.data, loading: false });
    });
  };

  closeModalDocumentos = () => {
    this.setState({ modalDocumentos: false });
  };

  showModalEliminar = () => {
    this.setState({ modalEliminar: true });
  };

  closeModalEliminar = () => {
    this.setState({ modalEliminar: false });
  };

  showModalVisualizar = () => {
    this.setState({ modalVisualizar: true });
  };

  closeModalVisualizar = () => {
    this.setState({ modalVisualizar: false });
  };

  showModal = () => {
    this.setState({ modal: true });
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  ModalNuevo = () => {
    this.showModal();
    this.setState({
      modalLabel: "Guardar",
      variante: "primary",
      modalAccion: "insert",
      modalTitle: "Registro nuevo",
      id: "",
      observaciones: "",
      check: [{
        check1: "",
        check2: "",
        check3: "",
        check4: "",
        check5: "",
        check6: "",
        check7: "",
        check8: "",
        check9: "",
        check10: "",
        check11: "",
        check12: "",
        check13: "",
        check14: "",
        check15: "",
        check16: "",
        check17: ""
      }],
      usuario_id: "",
      ambito_id: "",
    });
  };

  ModalModificar = (row) => {
    this.showModal();
    this.setState({
      modalLabel: "Modificar",
      variante: "warning",
      modalAccion: "update",
      modalTitle: "Modificación",
      id: row.id,
      observaciones: row.observaciones,
      check: JSON.parse(row.check),
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalVisualizar = (row) => {
    this.cargaDocumentos(row.id);
    this.showModalVisualizar();
    this.setState({
      modalLabel: "Visualizar",
      variante: "warning",
      modalAccion: "view",
      modalTitle: "Visualizar",
      id: row.id,
      observaciones: row.observaciones,
      check: JSON.parse(row.check),
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalEliminar = (row) => {
    this.showModalEliminar();
    this.setState({
      modalAccion: "delete",
      id: row.id,
    });
  };

  ejecutar = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    switch (this.state.modalAccion) {
      case "update":
        this.actualiza();
        break;
      case "insert":
        this.registra();
        break;
      case "delete":
        this.borra();
        break;
      default:
    }
  };

  registra = () => {
    let data = {
      //Recoger la información para el registro
      check: this.state.check,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios.post("http://143.198.191.211/api/F19", data, config).then((res) => {
      this.closeModal();
      toast.success(res.data.text, { autoClose: 1000 });
      this.cargaTabla();
      this.setState({ loading: false });
    });
  };

  actualiza = () => {
    let data = {
      //Recoger la información para el registro
      id: this.state.id,
      check: this.state.check,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios
      .put("http://143.198.191.211/api/F19/" + this.state.id, data, config)
      .then((res) => {
        this.closeModal();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  borra = () => {
    let data = {
      api_token: localStorage.api_token,
    };
    let config = {};
    axios
      .delete(
        "http://143.198.191.211/api/F19/" +
        this.state.id +
        "?api_token=" +
        localStorage.api_token,
        data,
        config
      )
      .then((res) => {
        this.closeModalEliminar();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  onChangeCheck = (seccion_nombre, i, e) => {
    let seccion = [...this.state[seccion_nombre]]
    let elemento = { ...seccion[i] }
    let this_nombre = e.target.name
    elemento[this_nombre] = e.target.checked
    seccion[i] = elemento
    this.setState({ [seccion_nombre]: seccion })
  };

  onChangeObservaciones = e => {
    this.setState({ observaciones: e.target.value });
  };
  onChangeUsuarioId = e => {
    this.setState({ usuario_id: e.target.value });
  };

  onChangeAmbitoId = e => {
    this.setState({ ambito_id: e.target.value });
  };



  onChangefrm_descripcion_doc = (e) => {
    this.setState({ frm_descripcion_doc: e.target.value });
  };

  GetActionFormat = (cell, row, idx, noEdit) => {
    return (
      <div>
        <ButtonGroup size="sm">
          <button
            type="button"
            className="btn btn-outline-info btn-sm"
            size="sm"
            onClick={() => this.ModalVisualizar(row)}
            data-tip="Visualizar"
          >
            <FontAwesomeIcon icon={faEye} size="lg" />
          </button>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            size="sm"
            onClick={() => this.ModalModificar(row)}
            data-tip="Modificar"
          >
            <FontAwesomeIcon icon={faEdit} size="lg" />
          </button>
          <Adjunto
            ambito_id={this.props.match.params.ambito_id}
            formato={"19"}
            id={row.id}
            disabled={noEdit}
          />
          <button
            type="button"
            className="btn btn-outline-danger btn-sm btn-elimina"
            size="sm"
            onClick={() => this.ModalEliminar(row)}
            data-tip="Eliminar"
            disabled={noEdit}
          >
            <FontAwesomeIcon icon={faTrash} size="lg" />
          </button>
        </ButtonGroup>
      </div>
    );
  };

  render() {
    const columns = [
      {
        dataField: "id",
        text: "ID",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "observaciones",
        text: "Observaciones",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },

      {
        dataField: "",
        text: "Acción",
        formatter: this.GetActionFormat,
        formatExtraData: this.state.noEdit,
        headerStyle: () => {
          return {
            width: "140px",
            zIndex: "99",
          };
        },
      },
    ];

    const { SearchBar } = Search;
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h3">Ayuda</Popover.Title>
        <Popover.Content>{this.state.input_tooltip}</Popover.Content>
      </Popover>
    );

    return (
      <Layout>
        <ToastContainer />
        <div
          id="cargando"
          className={this.state.loading ? "parentDisable" : ""}
          width="100%"
        >
          <div className="overlay-box">
            <PropagateLoader
              // css={}
              sizeUnit={"px"}
              size={25}
              color={"#000000"}
              loading={this.state.loading}
            />
          </div>
        </div>

        <div className="container mt-3">
          <div className="row">
            <div className="col">
              <h3 className="d-inline">ESTADOS FINANCIEROS</h3>
              <br />
              <small className="text-muted">
                Gestione la información del anexo numero 19 referente
                a estados financieros, para el ámbito {this.props.match.params.ambito_id}
              </small>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12 ">
              <ToolkitProvider
                keyField="id"
                data={this.state.f19s}
                columns={columns}
                bootstrap4
                search
              >
                {(props) => (
                  <div>
                    <div className="row">
                      <div className="col-6">
                        <ButtonToolbar aria-label="Toolbar with button groups">
                          <ButtonGroup
                            className="mr-2"
                            aria-label="First group"
                          >
                            <button
                              className="btn btn-primary btn-nuevo"
                              onClick={this.ModalNuevo}
                              data-tip="Nuevo"
                              disabled={this.state.noEdit}
                            >
                              <FontAwesomeIcon icon={faPlus} /> Nuevo
                            </button>
                          </ButtonGroup>
                          <ButtonGroup
                            className="mr-2"
                            aria-label="Second group"
                          >
                            <ReportePDF ambito_id={this.props.match.params.ambito_id}
                              anexo="19" />
                            <a
                              className="btn btn-primary"
                              data-tip="Descarga Excel"
                              target="_blank"
                              href={
                                "http://143.198.191.211/xlsx/?a=" +
                                this.props.match.params.ambito_id +
                                "&f=19"
                              }
                            >
                              <FontAwesomeIcon icon={faFileExcel} /> Descargar
                              Excel
                            </a>
                          </ButtonGroup>
                        </ButtonToolbar>
                      </div>
                      <div className="col-6 text-right">
                        <SearchBar
                          placeholder="Buscar..."
                          {...props.searchProps}
                          className="self-align-end"
                        />
                      </div>
                    </div>

                    <BootstrapTable
                      {...props.baseProps}
                      pagination={paginationFactory()}
                      hover
                    />
                  </div>
                )}
              </ToolkitProvider>{" "}
            </div>
          </div>
        </div>

        <Modal //***************************Modal para nuevo y modificar
          show={this.state.modal}
          onHide={this.closeModal}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Row>
              <Col xs="12">
                {(this.state.check).map((ele, i) =>
                  <Table striped bordered hover size="sm" className="normal">
                    <tbody>
                      <tr>
                        <td>I. Información contable:</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td className="indent-1">a) Estado de situación financiera</td>
                        <td>
                          <Form.Check type="checkbox" label="Marcar"
                            name="check1"
                            checked={ele.check1}
                            value={ele.check1}
                            onChange={(e) => this.onChangeCheck("check", i, e)} />
                        </td>
                      </tr>
                      <tr>
                        <td className="indent-1">b) Estado de variación en la hacienda pública</td>
                        <td>
                          <Form.Check type="checkbox" label="Marcar"
                            name="check2"
                            checked={ele.check2}
                            value={ele.check2}
                            onChange={(e) => this.onChangeCheck("check", i, e)} />
                        </td>
                      </tr>
                      <tr>
                        <td className="indent-1">c) Estado de flujo de efectivo</td>
                        <td>
                          <Form.Check type="checkbox" label="Marcar"
                            name="check3"
                            checked={ele.check3}
                            value={ele.check3}
                            onChange={(e) => this.onChangeCheck("check", i, e)} />
                        </td>
                      </tr>
                      <tr>
                        <td className="indent-1">d) Informes sobre pasivos contingentes</td>
                        <td>
                          <Form.Check type="checkbox" label="Marcar"
                            name="check4"
                            checked={ele.check4}
                            value={ele.check4}
                            onChange={(e) => this.onChangeCheck("check", i, e)} />
                        </td>
                      </tr>
                      <tr>
                        <td className="indent-1">e) Notas a los estados financieros</td>
                        <td>
                          <Form.Check type="checkbox" label="Marcar"
                            name="check5"
                            checked={ele.check5}
                            value={ele.check5}
                            onChange={(e) => this.onChangeCheck("check", i, e)} />
                        </td>
                      </tr>
                      <tr>
                        <td className="indent-1">f) Estado analítico del activo</td>
                        <td>
                          <Form.Check type="checkbox" label="Marcar"
                            name="check6"
                            checked={ele.check6}
                            value={ele.check6}
                            onChange={(e) => this.onChangeCheck("check", i, e)} />
                        </td>
                      </tr>
                      <tr>
                        <td className="indent-1">g) Estado analítico de la deuda y otros pasivos</td>
                        <td>
                        </td>
                      </tr>
                      <tr>
                        <td className="indent-2">1. Corto y largo plazo</td>
                        <td>
                          <Form.Check type="checkbox" label="Marcar"
                            name="check7"
                            checked={ele.check7}
                            value={ele.check7}
                            onChange={(e) => this.onChangeCheck("check", i, e)} />
                        </td>
                      </tr>
                      <tr>
                        <td className="indent-2">2. Fuentes de financiamiento</td>
                        <td>
                          <Form.Check type="checkbox" label="Marcar"
                            name="check8"
                            checked={ele.check8}
                            value={ele.check8}
                            onChange={(e) => this.onChangeCheck("check", i, e)} />
                        </td>
                      </tr>
                      <tr>
                        <td>II. Información presupuestaria:</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td className="indent-1">a) Estado analítico de ingresos, del que se derivará la presentación en:</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td className="indent-2">1. clasificación económica</td>
                        <td>
                          <Form.Check type="checkbox" label="Marcar"
                            name="check9"
                            checked={ele.check9}
                            value={ele.check9}
                            onChange={(e) => this.onChangeCheck("check", i, e)} />
                        </td>
                      </tr>
                      <tr>
                        <td className="indent-2">2. clasificación por fuente de financiamiento</td>
                        <td>
                          <Form.Check type="checkbox" label="Marcar"
                            name="check10"
                            checked={ele.check10}
                            value={ele.check10}
                            onChange={(e) => this.onChangeCheck("check", i, e)} />
                        </td>
                      </tr>
                      <tr>
                        <td className="indent-2">3. clasificación por concepto</td>
                        <td>
                          <Form.Check type="checkbox" label="Marcar"
                            name="check11"
                            checked={ele.check11}
                            value={ele.check11}
                            onChange={(e) => this.onChangeCheck("check", i, e)} />
                        </td>
                      </tr>
                      <tr>
                        <td className="indent-1">b) Estado analítico del ejercicio del presupuesto de egresos del que se derivarán las siguientes clasificaciones:</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td className="indent-2">1. Administrativa</td>
                        <td>
                          <Form.Check type="checkbox" label="Marcar"
                            name="check12"
                            checked={ele.check12}
                            value={ele.check12}
                            onChange={(e) => this.onChangeCheck("check", i, e)} />
                        </td>
                      </tr>
                      <tr>
                        <td className="indent-2">2. Económica y por objeto del gasto</td>
                        <td>
                          <Form.Check type="checkbox" label="Marcar"
                            name="check13"
                            checked={ele.check13}
                            value={ele.check13}
                            onChange={(e) => this.onChangeCheck("check", i, e)} />
                        </td>
                      </tr>
                      <tr>
                        <td className="indent-2">3. Funcional - programática.</td>
                        <td>
                          <Form.Check type="checkbox" label="Marcar"
                            name="check14"
                            checked={ele.check14}
                            value={ele.check14}
                            onChange={(e) => this.onChangeCheck("check", i, e)} />
                        </td>
                      </tr>
                      <tr>
                        <td className="indent-1">c) Endeudamiento neto, financiamiento menos amortización, del que derivará la clasificación por su origen en interno y externo;</td>
                        <td>
                          <Form.Check type="checkbox" label="Marcar"
                            name="check15"
                            checked={ele.check15}
                            value={ele.check15}
                            onChange={(e) => this.onChangeCheck("check", i, e)} />
                        </td>
                      </tr>
                      <tr>
                        <td className="indent-1">d) Intereses de la deuda</td>
                        <td>
                          <Form.Check type="checkbox" label="Marcar"
                            name="check16"
                            checked={ele.check16}
                            value={ele.check16}
                            onChange={(e) => this.onChangeCheck("check", i, e)} />
                        </td>
                      </tr>
                      <tr>
                        <td className="indent-1">e) Un flujo de fondos que resuma todas las operaciones y los indicadores de la postura fiscal</td>
                        <td>
                          <Form.Check type="checkbox" label="Marcar"
                            name="check17"
                            checked={ele.check17}
                            value={ele.check17}
                            onChange={(e) => this.onChangeCheck("check", i, e)} />
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                )}
              </Col>
              <Col xs="12">
                <Form.Label>
                  Observaciones:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="observaciones"
                  value={this.state.observaciones}
                  onChange={this.onChangeObservaciones}
                />
              </Col>
            </Form.Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal}>
              Cancelar
            </Button>
            <Button variant={this.state.variante} onClick={this.ejecutar} className="btn-ejecutar" disabled={this.state.noEdit} >
              {this.state.modalLabel}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para eliminar
          show={this.state.modalEliminar}
          onHide={this.closeModalEliminar}
          size="sm"
          centered
        >
          <Modal.Header>
            <Modal.Title>Eliminar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Seguro que desea eliminar este registro{" "}
            <strong>{this.state.nom_direccion}</strong> ?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalEliminar}>
              Cancelar
            </Button>
            <Button variant="danger" onClick={this.ejecutar} disabled={this.state.noEdit}>
              Eliminar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para visializar
          show={this.state.modalVisualizar}
          onHide={this.closeModalVisualizar}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header>
            <Modal.Title>Visualizar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Modal.Body className="show-grid">
              <Row>
                <Col xs={12} md={8}>
                  <h5>Datos del Registro</h5>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Check:
                    </Col>
                  </Row>

                </Col>
                <Col xs={12} md={4}>
                  <Row>
                    <Col xs={12}>
                      <h5>Archivos Adjuntos</h5>
                    </Col>
                    <Col xs={12}>
                      <ListaAdjuntos archivos={this.state.frm_lista_documentos} cargaDocumentos={this.cargaDocumentos} rowId={this.state.id} />
                    </Col>
                    <Col xs={12}>
                      <Galeria imagenes={this.state.frm_lista_documentos} />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Modal.Body>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalVisualizar}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>
        <ReactTooltip />
      </Layout >
    );
  }
}

export default F19s;
